import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;
export const WS_BASE = BACKEND.replace(/^http/, "ws");

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
});

http.interceptors.request.use((cfg) => {
  if (cfg.headers && cfg.headers.Authorization) return cfg;
  const t = localStorage.getItem("token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export function fmtErr(e) {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Bir hata oluştu";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return JSON.stringify(d);
}
